// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createTableTooltip_tooltip__2XEL8 {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  color: var(--white-10);\n  border-radius: 50%;\n  cursor: pointer;\n  border: 1px solid var(--white-10);\n}\n\n.createTableTooltip_active__3CyCs {\n  color: var(--primary-dark);\n  background-color: #fff;\n  border: 1px solid #ffffff;\n}", ""]);
// Exports
exports.locals = {
	"tooltip": "createTableTooltip_tooltip__2XEL8",
	"active": "createTableTooltip_active__3CyCs"
};
module.exports = exports;
